import { call, put } from 'redux-saga/effects';

import { api, notify } from 'services';
import { IFechRequest } from 'interfaces/fetch-duck';
import { requestErrorHandler } from 'utils';
import { FetchTransportActions } from 'store/ducks/transports';

export function* fetchTransportRequest(action: any) {
  try {
    const { id, onSuccess } = action as IFechRequest;
    const { data } = yield call(api.get, `/transports/${id}`);

    yield put(FetchTransportActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { onFailure } = action as IFechRequest;
    if (onFailure) onFailure();
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(FetchTransportActions.failure(errorMessage));
  }
}
